import { combineReducers } from 'redux';
import { all } from 'redux-saga/effects';

import bostonCenterlessUploadFlowReducer from './bostonCenterlessUploadFlow/data/reducer';
import bostonCenterlessUploadFlowSaga from './bostonCenterlessUploadFlow/data/sagas';

const reducer = combineReducers({
  bostonCenterlessUploadFlow: bostonCenterlessUploadFlowReducer,
});

const saga = function* () {
  yield all([bostonCenterlessUploadFlowSaga()]);
};

export { reducer, saga };
